import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  AttendanceDevice,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import biometric_machine from "../../../../../Assets/Images/biometric_machine.svg";
import directional_devices from "../../../../../Assets/Images/directional_devices.svg";
import single_device from "../../../../../Assets/Images/single_device.svg";
import SelectList from "../../../../../Component/SelectList/SelectList";
import CallOutNew from "Component/Headers/callOutNew";


const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class Biometric extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isbiometricdevice: false,
      isbidirection: false,
      helperText: "",
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("attendancedevicepolicy");
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);

    this.props.onRef({
      onNext: this.OnNext,
    });

    const text = this.props.Language.attendancedevicepolicy.HtBiometric;
    this.props.setHelperText({ helperText: text });
    const attendanceDeviceInfo = this.props.attendanceDeviceReducer;
    if (!this.isEmpty(attendanceDeviceInfo)) {
      const isbiometricdevice = attendanceDeviceInfo.isbiometricdevice
        ? attendanceDeviceInfo.isbiometricdevice
        : false;
      const isbidirection = attendanceDeviceInfo.isbidirection
        ? attendanceDeviceInfo.isbidirection
        : false;
      this.setState({ isbiometricdevice, isbidirection }, () => {
        this.UpdateAttendanceDeviceReducer();
      });
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  UpdateBiometricDeviceId(name, HtField, selectedItem) {
    this.HelperSliderFlag([HtField]);
    let { isbidirection } = this.state;
    if (selectedItem.displayvalue == false) {
      isbidirection = false;
    }
    this.setState({ [name]: selectedItem.displayvalue, isbidirection }, () => {
      this.UpdateAttendanceDeviceReducer();
    });
  }

  UpdateIsbidirection(name, HtField, selectedItem) {
    this.HelperSliderFlag([HtField]);
    this.setState({ [name]: selectedItem.displayvalue }, () => {
      this.UpdateAttendanceDeviceReducer();
    });
  }

  UpdateAttendanceDeviceReducer = () => {
    const attendanceDeviceInfo = this.props.attendanceDeviceReducer;
    attendanceDeviceInfo.isbiometricdevice = this.state.isbiometricdevice;
    attendanceDeviceInfo.isbidirection = this.state.isbidirection;
    if (this.state.isbidirection == true) {
      attendanceDeviceInfo.ismobiledevice = false;
      attendanceDeviceInfo.isgpsrestricted = false;
      attendanceDeviceInfo.iswebdevice = false;
      attendanceDeviceInfo.isiprestricted = false;
      attendanceDeviceInfo.allowedweddeviceip = [];
      attendanceDeviceInfo.allowedmobiledevicegps = [];
    }
    this.props.AttendanceDevice({ ...attendanceDeviceInfo });
  };

  OnNext = () => {
    this.UpdateAttendanceDeviceReducer();
    this.props.click();
  };

  OnSave(flag) {
    this.UpdateAttendanceDeviceReducer();
    this.props.SaveDevicePolicy(flag);
  }

  OnCancel() {
    this.props.Cancel(true);
  }

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Language.attendancedevicepolicy[${HtField}]`);
    // let text = this.props.Language.attendancedevicepolicy[HtField]
    this.props.setHelperText({ helperText: text, open: true });
  }

  render() {
    const { classes } = this.props;

    const options = [
      {
        displayvalue: true,
        displayname: <FormattedMessage id="LbYes" defaultMessage="Yes" />,
      },
      {
        displayvalue: false,
        displayname: <FormattedMessage id="LbNo" defaultMessage="No" />,
      },
    ];
    return (
      <div className={classes.root}>
        <div className="stepper-scroller padding-top-0">
          <div className="stepper-scroller-content">
            <div className="inner-wrapper opaque">
              <div className="form-group">
                <p className="depedent-select-list-head">
                  <FormattedMessage
                    id="LbEnableBiometricAttendance"
                    defaultMessage="Would you like to enable biometric attendance ?"
                  />
                </p>
                <div className="device-form-img">
                  <img src={biometric_machine} align="left" height="100" />
                </div>
                <div className="">
                  <SelectList
                    data={options}
                    Selected={this.state.isbiometricdevice}
                    onSelected={this.UpdateBiometricDeviceId.bind(
                      this,
                      "isbiometricdevice",
                      "HtIsBiometricDevice",
                    )}
                  />
                </div>
              </div>
              {/* {this.state.isbiometricdevice == true ? <div className="bottom-border"></div> : ''} */}
            </div>

            <div>
              {this.state.isbiometricdevice && 
            <CallOutNew
              classnames="bg-light-blue display-flex margin-bottom-16"
              header={<span>Please make sure you configure your biometric machines as IN machine & OUT machine in the biometric configuration <span><a target="_blank" href="/app/track/biometric"><span className="view-more-link " style={{color:"#1e8ced", fontWeight:"bold", fontSize:12}}>here</span></a></span> </span>}
              emoji="ℹ️"
              textcolor="#1e8ced"
            />
          }

              <Collapse
                in={this.state.isbiometricdevice}
                timeout="auto"
                unmountOnExit
                className="overflow-initial"
              >
                <div className="opaque">
                  <div className="form-group">
                    <p className="depedent-select-list-head">
                      <FormattedMessage
                        id="LbUseDirectionalDevices"
                        defaultMessage="Do you wish to track attendance with separate device for recording in-time and a separate device for recording out-time (use in/out directional devices) ?"
                      />
                    </p>
                    <div className="display-flex">
                      {this.state.isbidirection ? (
                        <img
                          src={directional_devices}
                          align="left"
                          height="300"
                        />
                      ) : (
                        <img src={single_device} align="left" height="300" />
                      )}
                    </div>
                    <div className="">
                      <SelectList
                        data={options}
                        Selected={this.state.isbidirection}
                        onSelected={this.UpdateIsbidirection.bind(
                          this,
                          "isbidirection",
                          "HtIsBidirection",
                        )}
                      />
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
            {/* <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={this.OnNext.bind(this)}
            >
              <FormattedMessage id="BtNext" defaultMessage="Next" />
            </Button> */}
            {/* <div className="draftbutton-wrapper">
                                <div className="draftclosebutton cursour-pointer" onClick={this.OnCancel.bind(this)}>X <span className="draftclosebutton-text"><FormattedMessage id="BtClose" defaultMessage="Close" /></span></div>

                                <div className="draftbutton-innerwrapper">
                                    {this.state.isdraft == true ?
                                    <span className="draftbutton cursour-pointer" onClick={this.OnSave.bind(this, 'SaveAsDraft')}>
                                        <Done />
                                        <span className="draft-option"><FormattedMessage id="BtSaveAsDraft" defaultMessage="Save As Draft" /></span>
                                    </span>
                                    :
                                    <span className="draftbutton cursour-pointer" onClick={this.OnSave.bind(this, 'Save')}>
                                        <DoneAllIcon />
                                        <span className="draft-option"><FormattedMessage id="BtSave" defaultMessage="Save" /></span>
                                    </span>
                                    }
                                </div>
                            </div> */}
          </div>
        </div>
      </div>
    );
  }
}

Biometric.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  attendanceDeviceReducer: state.attendanceDeviceReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      AttendanceDevice: (data) => AttendanceDevice(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(Biometric)));
